<template>
<div>
  <b-card v-if="!isMultipleAnnouncementAllowed" 
            border-variant="secondary"
            text-variant="secondary"
            :title="$t('announcements.title')"
            align="center"
            style="max-width: 40rem;"
            class="mx-auto">
        <b-card-text class="text-dark">{{propertyInfo.tenantPortalAnnouncements}}</b-card-text>
  </b-card>
  <b-card v-if="isMultipleAnnouncementAllowed" 
      border-variant="secondary"
      align="center"
      class="mx-auto"
      no-body>
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button block v-b-toggle.announcementsCollapse variant="secondary">{{ $t('nav.announcements') }}</b-button>
    </b-card-header>
    <b-collapse id="announcementsCollapse" visible >
      <b-card-body >
        <unitAnnouncements class="mt-2 text-center" :caption="$t('announcements.title')"/>
      </b-card-body>
    </b-collapse>
  </b-card>
 </div>
</template>

<script>
import store from "@/store/store";
import unitAnnouncements from "@/components/AnnouncementsTable.vue";

export default {
  name:"Announcements",
  async mounted () {
    await store.dispatch("loadAnnouncements")
  },
  components: {
    unitAnnouncements
  },
  computed: {
    isMultipleAnnouncementAllowed() {
      return this.$store.getters.isMultipleAnnouncementAllowed;
    },
    propertyInfo() {
      return this.$store.getters.getPropertyInfo;
    }
  },
  methods: {
    hasAnnouncements(){
      if(this.$store.getters.isAnnouncementPresent !== false){
        return 1
      }
      return 0
    }
  }
}
</script>